import { useState } from 'react';
import { locationData, yandexMapEmbedUrl } from './locationData';
import styles from './LocationSection.module.scss';

export function LocationMap() {
  const [isInteractive, setIsInteractive] = useState(false);

  return (
    <div className={styles.mapViewport} aria-label="Карта расположения Лучезарной Долины">
      <div className={styles.mapFallback}>
        <span>Лучезарная Долина</span>
        <a href={locationData.mapLink} target="_blank" rel="noreferrer">
          Открыть карту
        </a>
      </div>
      <iframe
        className={`${styles.mapFrame} ${isInteractive ? styles.mapFrameInteractive : ''}`}
        src={yandexMapEmbedUrl}
        title="Лучезарная Долина на Яндекс Картах"
        loading="lazy"
        allowFullScreen
      />
      <button
        className={styles.mapActivator}
        type="button"
        aria-pressed={isInteractive}
        onClick={() => setIsInteractive((value) => !value)}
      >
        {isInteractive ? 'Отключить управление картой' : 'Перемещать карту'}
      </button>
    </div>
  );
}
